import { useIonRouter } from '@ionic/react';
import { useBreadcrumbStore } from '../../store/useBreadcrumbStore';

export function Breadcrumb() {
  const router = useIonRouter();
  const { items } = useBreadcrumbStore();

  if (items.length === 0) return null;

  return (
    <nav className="flex items-center gap-1 text-sm">
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={idx} className="flex items-center gap-1">
            {idx > 0 && <span className="text-gray-300">/</span>}
            {item.path && !isLast ? (
              <button
                onClick={() => router.push(item.path!, 'none')}
                className="text-blue-600 hover:text-blue-800 hover:underline"
              >
                {item.label}
              </button>
            ) : (
              <span className={isLast ? 'text-gray-700 font-medium' : 'text-gray-500'}>
                {item.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
